'use client';

import React from 'react';

import { VisuallyHidden } from '@depop/web-ui-kit/VisuallyHidden';
import clsx from 'clsx';

import styles from './styles.module.css';

export type RadioSelectorState = 'selected' | 'faded' | 'default';

export type RadioSelectorProps = {
  state?: RadioSelectorState;
  onChange: () => void;
  children: React.ReactNode;
  name: string;
  value: string;
  'aria-labelledby'?: string;
  error?: boolean;
  hideIndicator?: boolean;
  hoverable?: boolean;
};

export function RadioSelector({
  state = 'default',
  onChange,
  children,
  name,
  value,
  error = false,
  'aria-labelledby': ariaLabelledBy,
  hideIndicator,
  hoverable,
}: RadioSelectorProps) {
  function handleChange() {
    onChange();
  }

  return (
    <label
      className={clsx(styles.label, {
        [styles.labelSelected]: state === 'selected',
        [styles.fadeOnHover]: hoverable,
      })}
    >
      <VisuallyHidden>
        <input
          type="radio"
          name={name}
          value={value}
          checked={state === 'selected'}
          onChange={handleChange}
          aria-labelledby={ariaLabelledBy}
        />
      </VisuallyHidden>
      {children}
      {state === 'faded' && (
        <div className={styles.fadeOverlay} aria-hidden="true" />
      )}
      {!hideIndicator && state === 'selected' && (
        <span
          className={clsx(styles.radioIndicator, styles.radioIndicatorSelected)}
          aria-hidden="true"
        />
      )}
      {!hideIndicator && (state === 'default' || state === 'faded') && (
        <span
          className={clsx(
            styles.radioIndicator,
            error && styles.radioIndicatorError
          )}
          aria-hidden="true"
        />
      )}
    </label>
  );
}
